import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from 'components/ui/dialog'
import { Button } from 'components/ui/button'
import { Compass } from 'lucide-react'
import { tourConfig, TOUR_STORAGE_KEY } from './dashboardTour'
import { patchUser } from 'slices/authSlice'

const TourPrompt: React.FC = () => {
	const dispatch = useDispatch()
	const user = useSelector((state: any) => state.userLogin.userInfo)
	const [showPrompt, setShowPrompt] = useState(false)

	useEffect(() => {
		if (!user) return

		// Check if tour has been completed or dismissed
		const tourCompleted =
			user.tourCompleted || localStorage.getItem(TOUR_STORAGE_KEY) === 'true'

		// Show prompt only if user just completed onboarding (firstTime was recently set to false)
		// and tour hasn't been completed
		if (!tourCompleted && !user.firstTime && user.onboardingStep >= 6) {
			// Small delay to let the dashboard render first
			const timer = setTimeout(() => setShowPrompt(true), 1000)
			return () => clearTimeout(timer)
		}
	}, [user])

	const startTour = () => {
		setShowPrompt(false)

		const driverObj = driver({
			...tourConfig,
			onDestroyStarted: () => {
				completeTour()
				driverObj.destroy()
			},
		})

		driverObj.drive()
	}

	const completeTour = () => {
		localStorage.setItem(TOUR_STORAGE_KEY, 'true')
		if (user?._id) {
			dispatch(patchUser({ userid: user._id, updates: { tourCompleted: true } }))
		}
	}

	const dismissTour = () => {
		setShowPrompt(false)
		completeTour()
	}

	if (!showPrompt) return null

	return (
		<Dialog open={true} onClose={dismissTour}>
			<DialogContent className="max-w-sm">
				<DialogHeader>
					<div className="flex items-center gap-3">
						<div className="w-10 h-10 rounded-lg flex items-center justify-center bg-[#0080fe]/10 text-[#0080fe]">
							<Compass className="w-5 h-5" />
						</div>
						<div>
							<DialogTitle>Quick Tour</DialogTitle>
							<DialogDescription>
								Would you like a quick tour of MYDealTeams?
							</DialogDescription>
						</div>
					</div>
				</DialogHeader>

				<div className="px-5 py-3">
					<p className="text-sm text-gray-600">
						We'll walk you through the key features in about 30 seconds.
					</p>
				</div>

				<DialogFooter>
					<Button variant="ghost" onClick={dismissTour}>
						No Thanks
					</Button>
					<Button onClick={startTour}>
						Start Tour
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}

export default TourPrompt
